import { jsx as _jsx } from "react/jsx-runtime";
import { mergeProps } from "./merge-props.js";
export const InnerPre = ({ merge, ...rest }) => {
    const { _stack, ...result } = mergeProps(merge, rest);
    const [Next, ...stack] = _stack;
    if (Next) {
        return _jsx(Next, { _stack: stack, ...result });
    }
    else {
        const { _ref, data, children, ...props } = result;
        return (_jsx("pre", { ...props, ref: _ref, "data-ch": true, children: _jsx("div", { style: { minWidth: "fit-content" }, children: children }) }));
    }
};
export function getPreRef(props) {
    const p = props;
    if (!(p === null || p === void 0 ? void 0 : p._ref)) {
        throw new Error("`getPreRef` can only be used inside `PreWithRef`");
    }
    return p === null || p === void 0 ? void 0 : p._ref;
}
export const InnerLine = ({ merge, ...rest }) => {
    const { _stack, ...result } = mergeProps(merge, rest);
    const [next, ...stack] = _stack;
    if (next) {
        const { Component, annotation } = next;
        return _jsx(Component, { _stack: stack, ...result, annotation: annotation });
    }
    else {
        const { lineNumber, totalLines, indentation, data, annotation, ...props } = result;
        return _jsx("div", { ...props });
    }
};
export const InnerToken = ({ merge, ...rest }) => {
    const { _stack, ...result } = mergeProps(merge, rest);
    const [next, ...stack] = _stack;
    if (next) {
        const { Component, annotation } = next;
        return _jsx(Component, { _stack: stack, ...result, annotation: annotation });
    }
    else {
        const { value, data, ...props } = result;
        return _jsx("span", { ...props, children: value });
    }
};
